export default __webpack_public_path__ + "static/media/scan_hub_in_app.5e5bee88.png";